var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered has-text-primary"},[_c('i',{staticClass:"fad fa-spinner-third fa-3x fa-spin"})])}]

export { render, staticRenderFns }